import { createRequest } from 'Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from 'Helpers/TokenHelper'
import { setEnabled, setPricelists as setPricelistData, setSites } from 'Slices/Settings/SiteSlice'

const getSites = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const sites = state.present.configuration.sites

  if (!state.present.article.serverConfig || !token || !sites) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return createRequest(
    '/api/SiteSettings/allSites?config=' + state.present.article.serverConfig,
    'GET',
    null,
    token,
    true,
    true,
  )
    .then(response => response.json())
    .then(data => {
      if (data) {
        dispatch(setSites(data))
      }
    })
}

const getEnabledSites = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const sites = state.present.configuration.sites

  if (!state.present.article.serverConfig || !token || !sites) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  createRequest(
    '/api/SiteSettings/enabledSites?config=' + state.present.article.serverConfig,
    'GET',
    null,
    token,
    true,
    true,
  )
    .then(response => response.json())
    .then(data => {
      if (data) {
        dispatch(setEnabled(data))
      }
    })
}

const getSitePricelists = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const sites = state.present.configuration.sites
  const pricelistTypeFilter = state.present.configuration.pricelistTypeFilter

  if (!state.present.article.serverConfig || !token || !sites) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  return createRequest(
    `/api/SiteSettings/pricelistsToExport?config=${state.present.article.serverConfig}&pricelistTypeFilter=${pricelistTypeFilter}`,
    'GET',
    null,
    token,
    true,
    true,
  )
    .then(response => response.json())
    .then(data => {
      if (data) {
        dispatch(setPricelistData(data))
      }
    })
}

const savePricelists = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const sites = state.present.configuration.sites
  const pricelists = state.present.site.pricelists

  if (!state.present.article.serverConfig || !token || !sites) {
    return new Promise(resolve => {
      resolve([])
    })
  }
  //TODO: Rincontrollare il funzionamento, con 1 listino funziona, con 2 o più listini no
  Object.entries(pricelists).forEach(([key, value], index, array) => {
    const pricelistArray: string[] = (value as string[]) ?? []
    const siteNumber = key.at(-1)
    createRequest(
      '/api/SiteSettings/' + siteNumber + '/setPricelists?config=' + state.present.article.serverConfig,
      'POST',
      pricelistArray,
      token,
      true,
      true,
    )
      .then(response => response.json())
      .then(data => {
        if (index === array.length - 1) {
          dispatch(getSitePricelists())
        }
      })
  })
}

const updateEnableStatus = () => (dispatch, getState) => {
  const state = getState()
  const token = getTokenFromSessionStorage()
  const sites = state.present.site.sites
  const enabled = state.present.site.enabled
  const sitesConfig = state.present.configuration.sites

  if (!state.present.article.serverConfig || !token || !sitesConfig) {
    return new Promise(resolve => {
      resolve([])
    })
  }

  sites.forEach((site, index, array) => {
    const isEnable = !!enabled.find(x => x === parseInt(site.at(-1)))
    const isEnableOrDisable = isEnable ? 'enable' : 'disable'
    const siteNumber = parseInt(site.at(-1))

    createRequest(
      '/api/SiteSettings/' + siteNumber + '/' + isEnableOrDisable + '?config=' + state.present.article.serverConfig,
      'POST',
      null,
      token,
      true,
      true,
    )
      .then(response => response.json())
      .then(data => {
        if (index === array.length) {
          dispatch(getEnabledSites())
        }
      })
  })
}

export { getSites, getEnabledSites, getSitePricelists, savePricelists, updateEnableStatus }
